var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"template-details-wrapper"},[_c('labeled-item-list',{attrs:{"readonly":"","labeled-items":_vm.templateDetailItems,"edit-type":"text-input","title":"Template Details"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }